// Same 11-name Google Calendar palette Event/Booking/Holiday already use
// (see ColorsWrapper on the backend — keep in sync with GOOGLE_COLOR_CODES).
// `value` doubles as the CSS class name (`.tomato`, `.peacock`, ...) defined
// in app/assets/tailwind/application.css — plain hand-authored CSS, not
// Tailwind-generated utilities, so referencing it dynamically here is safe
// (nothing for Tailwind's JIT/purge to miss).
export const TASK_COLORS = [
  { value: 'tomato',    label: 'Tomato' },
  { value: 'flamingo',  label: 'Flamingo' },
  { value: 'tangerine', label: 'Tangerine' },
  { value: 'banana',    label: 'Banana' },
  { value: 'peacock',   label: 'Peacock' },
  { value: 'sage',      label: 'Sage' },
  { value: 'basil',     label: 'Basil' },
  { value: 'blueberry', label: 'Blueberry' },
  { value: 'lavender',  label: 'Lavender' },
  { value: 'grape',     label: 'Grape' },
  { value: 'graphite',  label: 'Graphite' },
]

// Mirrors ColorsWrapper::GOOGLE_COLOR_CSS_CODE — used for the drawer's
// color accent bar, which needs a live hex value as the user picks a swatch
// (Task#color_css_code from the API only reflects the last-saved color).
export const TASK_COLOR_HEX = {
  lavender:  '#7986cb',
  sage:      '#33b679',
  grape:     '#8f25aa',
  flamingo:  '#e77c73',
  banana:    '#f6bf27',
  tangerine: '#f5521d',
  peacock:   '#4386f5',
  graphite:  '#616161',
  blueberry: '#3f51b5',
  basil:     '#098143',
  tomato:    '#d50201',
}

// A very light wash of a task's own color, used to tint whole surfaces: the
// checklist's rows (TaskRow.vue) and the board's cards (TaskCard.vue).
//
// One alpha for both themes, same reasoning as `accentWash` in
// TaskDetailPage.vue: a low percentage of a saturated hue is a pale tint over
// white and a soft haze over the dark surface, so branching on the current
// theme buys nothing. Deliberately lower than that page's 12% — these repeat
// across every row and card of a list, and at 12% a full screen of them reads
// as a color chart rather than a list.
const TINT_ALPHA = '14' // 0x14/255 ≈ 8%
const TINT_ALPHA_HOVER = '24' // 0x24/255 ≈ 14%
// Only ever seen in motion — the opening frame of a newly created row's
// arrival animation, which settles back to TINT_ALPHA within the same second.
// Strong enough to read as a flash of the task's color at a glance, which is
// why it sits well above the hover value rather than a step past it.
const TINT_ALPHA_STRONG = '38' // 0x38/255 ≈ 22%

// Returned as CSS custom properties rather than a ready-made background,
// because the hover state needs a selector and an inline style cannot carry
// one. Tailwind classes are not an option either: the palette is dynamic
// backend data, so `bg-${color}/10` would never survive the build (see
// CLAUDE.md on dynamic colors from the backend).
//
// `colorCssCode` is Task#color_css_code from the API. Only #RRGGBB is
// accepted: the alphas above are appended as a hex suffix, which is
// meaningless on any other notation, and a malformed value would otherwise
// yield an invalid color and drop the tint with no clue why.
export function taskTintVars(colorCssCode) {
  const hex = /^#[0-9a-fA-F]{6}$/.test(colorCssCode || '') ? colorCssCode : TASK_COLOR_HEX.peacock
  return {
    '--task-tint': `${hex}${TINT_ALPHA}`,
    '--task-tint-hover': `${hex}${TINT_ALPHA_HOVER}`,
    '--task-tint-strong': `${hex}${TINT_ALPHA_STRONG}`,
  }
}
